import React, {useState, useEffect} from 'react';
import '../HomePage/Style.css';
import '../HomePage/Kalender';
import kalenderCjjbf from '../HomePage/Kalender';
import { Link, useLocation } from 'react-router-dom';  // Import Link from react-router-dom
import useTitle from '../../useTitle';

const HomePage = () => {
    useTitle("Welcome to the Real Combat Sport!");
    // eslint-disable-next-line no-unused-vars
    const [isOpen, setIsOpen] = useState(false);
    
    // Close the navbar when a link is clicked
    const handleLinkClick = (url) => {
        setIsOpen(false); // Close the navbar
        window.location.href = url; // Force navigation to the specific URL
    };

    const handleContactLink = (url) => {
        if (url === '/contact') {
            // Scroll to the contact section if it's the same page
            document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
        }
    };

    const location = useLocation();

    useEffect(() => {
        if (location.hash === '#contact') {
            const section = document.getElementById('contact');

            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);


  return (
    <>
        {/* Home Container */}
        <div className='homePageContainer'>
            <div className='logoAndNameOfWebsite'>
                <img src='/cjjbf-logo-new-2026.png' alt='combat ju-jutsu belgian federation logo' className='logoImage' />
                <h1 className='titleOfWebsite'>COMBAT JU-JUTSU BELGIAN FEDERATION</h1>
            </div>
            <div className='contactButtonContainer'>
                <Link onClick={() => handleContactLink('/contact')} className='contactButton'>CONTACT US</Link>
            </div>
        </div>

        {/* Slogan of website section */}
        <div className='homePageContainerTwo'>
            <h1 className='sloganOfWebsite'>WELCOME TO THE REAL COMBAT SPORT!</h1>
        </div>

        {/* About Combat Ju-Jutsu Section */}
        <div className='aboutCombatJuJutsu'>
            <div className='titleAndDescriptionOfCombatJuJutsu'>
                <div className='titleAboutCombatJuJutsu'>
                    <h1 className='titleCombat'>ABOUT COMBAT JU-JUTSU</h1>
                </div>
                <div className='descriptionAboutCombatJuJutsu'>
                    <p>This is a sport and a self-defense! This combination of skills to survive and win in a real combat with one or more opponents with the full sports competition experience. The combination of skills and techniques of a sports fight and real combat provides the most universal training for a person!</p>
                    <p>Combat Ju-Jutsu first and foremost is the art of self-defense and applied technique for military and police use.</p>
                    <p>Combat Ju-Jutsu is something that is put between the two strikes!</p>
                </div>
                <div className='combatJuJutsuPageButton'>
                    <Link onClick={() => handleLinkClick('/whatiscombatjujutsu')} className='combatJuJutsuButton'>Combat Ju-Jutsu Page</Link>
                </div>
            </div>
            <div className='imageOfCombatJuJutsu'>
                <img src='/images/combat1.jpg' alt='about combat ju jutsu' className='imageOfCombat'/>
            </div>
        </div>

        <div className="dividerTwo"></div>

        {/* Kalender Section */}
        <div className='federationContainer'>
            <h1 className='kalenderTitle'>CALENDAR 2026-2027</h1>
            {
                kalenderCjjbf.map((item) => {
                    return (
                        <a key={item.id} className='kalenderItem' href={item.hyperlink} target='_blank' rel='noreferrer'>
                            <p className='titleOfEvent'>{item.title}</p>
                            <p className='dateOfEvent'>{item.subtitle}</p>
                            <p className='dateOfEvent'>{item.dateEvent}</p>
                            <p className='placeOfEvent'>{item.location}</p>
                        </a>
                    )
                })
            }
        </div>

        <div className="dividerThree"></div>

        <div className='titleSponsorsOfFederation'>
            <h1 className='titleSponsors'>PARTNERS</h1>
        </div>

        {/* Sponsors Sectie */}
        <div className='sponsorsOfTheFederation'>
            <div className='sponsorsOfFederationSection'>
                <a href='https://bubbelsgroup.com' target='_blank' rel='noreferrer'><img src='/images/bubblesgroup-logo.png' className='logoSponsor' alt='logo of bubblesgroup' /></a>
                <a href='https://mays.be' target='_blank' rel='noreferrer'><img src='/images/mays-logo.png' className='logoSponsor' alt='logo of mays' /></a>
                <a href='https://bierhandelverschueren.be' target='_blank' rel='noreferrer'><img src='/images/drankencentrale-verschueren.png' className='logoSponsor' alt='logo of bierhandel verschueren' /></a>
                <a href='https://www.akaibarahoboken.com' target='_blank' rel='noreferrer'><img src='/images/aka-i-bara-new-logo-website.png' className='logoSponsor' alt='logo of aka i bara hoboken' /></a>
                <a href='https://www.schmersal.be/home' target='_blank' rel='noreferrer'><img src='/images/schmersal_logo_rgb.png' className='logoSponsor' alt='logo of schmersal belgium' /></a>
                <a href='https://gevitec.be' target='_blank' rel='noreferrer'><img src='/images/gevitec-logo-website-1.png' className='logoSponsor' alt='logo of gevitec belgium' /></a>
                <a href='#renovatiewerken'><img src='/images/renovatiewerken.jpg' className='logoSponsor' alt='logo of renovatiewerken' /></a>
                <a href='https://www.facebook.com/p/Aquila-Detailing-61550077534258/' target='_blank' rel='noreferrer'><img src='/images/aquila-detailing.png' className='logoSponsor' alt='logo of aquila detailing' /></a>
                <a href='https://www.bouwmaterialenschutters.be' target='_blank' rel='noreferrer'><img src='/images/bouwwerken-schutters-1.png' className='logoSponsor' alt='logo of bouwwerken schutters' /></a>
            </div>
            <div className='sponsorsOfFederationSection'>
                <a href='https://bubbelsgroup.com' target='_blank' rel='noreferrer'><img src='/images/bubblesgroup-logo.png' className='logoSponsor' alt='logo of bubblesgroup' /></a>
                <a href='https://mays.be' target='_blank' rel='noreferrer'><img src='/images/mays-logo.png' className='logoSponsor' alt='logo of mays' /></a>
                <a href='https://bierhandelverschueren.be' target='_blank' rel='noreferrer'><img src='/images/drankencentrale-verschueren.png' className='logoSponsor' alt='logo of bierhandel verschueren' /></a>
                <a href='https://www.akaibarahoboken.com' target='_blank' rel='noreferrer'><img src='/images/aka-i-bara-new-logo-website.png' className='logoSponsor' alt='logo of aka i bara hoboken' /></a>
                <a href='https://www.schmersal.be/home' target='_blank' rel='noreferrer'><img src='/images/schmersal_logo_rgb.png' className='logoSponsor' alt='logo of schmersal belgium' /></a>
                <a href='https://gevitec.be' target='_blank' rel='noreferrer'><img src='/images/gevitec-logo-website-1.png' className='logoSponsor' alt='logo of gevitec belgium' /></a>
                <a href='#renovatiewerken'><img src='/images/renovatiewerken.jpg' className='logoSponsor' alt='logo of renovatiewerken' /></a>
                <a href='https://www.facebook.com/p/Aquila-Detailing-61550077534258/' target='_blank' rel='noreferrer'><img src='/images/aquila-detailing.png' className='logoSponsor' alt='logo of aquila detailing' /></a>
                <a href='https://www.bouwmaterialenschutters.be' target='_blank' rel='noreferrer'><img src='/images/bouwwerken-schutters-1.png' className='logoSponsor' alt='logo of bouwwerken schutters' /></a>
            </div>
        </div>

        {/* Headquarters and contact section */}
        <div id="contact" className='headquartersOfTheFederation'>
            <img src='/cjjbf-logo-new-2026.png' className='logoHeadQuarter' alt='logo of cjjbf' />
            <div className='adresOfTheHeadQuarters'>
                <h3 className='titleAdres'>HEADQUARTERS</h3>
                <p>Baron Sadoinestraat 32 -</p>
                <p>2660 Hoboken (Antwerpen)</p>
                <h3 className='titleContact'>CONTACT</h3>
                <a className='bellenContact' href="tel:+32485120254">Phone: +32 (0) 485 12 02 54</a><br/>
                <a className='emailContact' href="mailto:cjjbfcontact@gmail.com">E-mail: cjjbfcontact@gmail.com</a>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2501.57997093033!2d4.33260545209873!3d51.17153259909231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3f3ed9baf8d45%3A0x3271b5775c756b3f!2sBaron%20Sadoinestraat%2032%2C%202660%20Antwerpen!5e0!3m2!1snl!2sbe!4v1784125726163!5m2!1snl!2sbe" width="500" height="320" allowfullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title='headquartersOfCjjbf' className='googleMapsCjjbf'></iframe>
        </div>
    </>
  );
}

export default HomePage;